import React from 'react';

export class ErrorBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(err, info) { console.error(err, info); }
  render() {
    if (this.state.hasError) {
      return <div className="alert alert-danger">Something went wrong.</div>;
    }
    return this.props.children;
  }
}
